import React from 'react';
import { KatButton } from '@amzn/katal-react';
import MultiSelectDropdown from '../MultiSelectDropdown';
import { StuckFilters } from './types';

interface StuckFilterBarProps {
    filters: StuckFilters;
    facetDefs: Array<[string, string, string]>;
    facetOptions: (key: string) => string[];
    regionLabel: string;
    setFacet: (key: string, values: string[]) => void;
    clearFacets: () => void;
    onCsv: () => void;
}

const StuckFilterBar: React.FC<StuckFilterBarProps> = ({
    filters, facetDefs, facetOptions, regionLabel, setFacet, clearFacets, onCsv,
}) => (
    <div className="sw-filterbar">
        <div className="sw-filterbar__row">
            <span className="sw-filterbar__label">Region</span>
            <span className="sw-region">{regionLabel}</span>
        </div>

        <div className="sw-filterbar__row sw-filterbar__facets">
            {facetDefs.map(([key, label]) => (
                <div className="sw-facet" key={key}>
                    <MultiSelectDropdown
                        label={label}
                        placeholder={`All ${label}`}
                        options={facetOptions(key)}
                        selectedOptions={filters.facets[key] || []}
                        onSelectionChange={(vals) => setFacet(key, vals)}
                    />
                </div>
            ))}
        </div>

        <div className="sw-filterbar__row sw-filterbar__actions">
            <KatButton variant="secondary" label="Clear filters" onClick={clearFacets} />
            <KatButton variant="secondary" label="Download (CSV)" onClick={onCsv} />
        </div>
    </div>
);

export default StuckFilterBar;
